import { useContext } from 'react';

import { PermissionContext, type PermissionContextType } from './context';

export const usePermission = (): PermissionContextType => {
  const context = useContext(PermissionContext);

  if (!context) {
    throw new Error('usePermission must be used within a PermissionProvider');
  }

  return context;
};
